// Test IDs for the Natant AI landing page.
export const NAV = {
	root: 'nav-root',
	logo: 'nav-logo',
	linkThesis: 'nav-link-thesis',
	linkWhitepaper: 'nav-link-whitepaper',
	linkVectors: 'nav-link-vectors',
	linkCohort: 'nav-link-cohort',
	applyButton: 'nav-apply-button',
};

export const ANNOUNCEMENT = {
	bar: 'announcement-bar',
	link: 'announcement-link',
	close: 'announcement-close',
};

export const SUBSTRATE = {
	section: 'substrate-section',
	tile: 'substrate-tile',
};

export const STATS = {
	section: 'stats-section',
	item: 'stats-item',
};

export const FAQ = {
	section: 'faq-section',
	item: 'faq-item',
	trigger: 'faq-trigger',
};

export const HERO = {
	section: 'hero-section',
	headline: 'hero-headline',
	subline: 'hero-subline',
	ctaThesis: 'hero-cta-thesis',
	ctaWhitepaper: 'hero-cta-whitepaper',
	ctaCohort: 'hero-cta-cohort',
	scrollHint: 'hero-scroll-hint',
};

export const THESIS = {
	section: 'thesis-section',
	pillarComposable: 'thesis-pillar-composable',
	pillarAgentic: 'thesis-pillar-agentic',
	pillarNative: 'thesis-pillar-native',
};

export const WHITEPAPER = {
	section: 'whitepaper-section',
	link: 'whitepaper-read-link',
	sectionItem: 'whitepaper-section-item',
};

export const VECTORS = {
	section: 'vectors-section',
	item: 'vectors-item',
};

export const MARQUEE = {
	section: 'marquee-section',
};

export const COHORT = {
	section: 'cohort-section',
	form: 'cohort-form',
	organisationInput: 'cohort-organisation-input',
	emailInput: 'cohort-email-input',
	websiteInput: 'cohort-website-input',
	submitButton: 'cohort-submit-button',
	successMessage: 'cohort-success-message',
	errorMessage: 'cohort-error-message',
	seatsIndicator: 'cohort-seats-indicator',
};

export const FOOTER = {
	root: 'footer-root',
	closingNote: 'footer-closing-note',
};

export const ONBOARD = {
	page: 'onboard-page',
	primaryInput: 'onboard-primary-input',
	urlInput: 'onboard-url-input',
	toolChip: 'onboard-tool-chip',
	analogyInput: 'onboard-analogy-input',
	analyseButton: 'onboard-analyse-button',
	processing: 'onboard-processing',
	patternCard: 'onboard-pattern-card',
	patternAccept: 'onboard-pattern-accept',
	patternDismiss: 'onboard-pattern-dismiss',
	patternSlot: 'onboard-pattern-slot',
	fallbackSelect: 'onboard-fallback-select',
	orgInput: 'onboard-org-input',
	emailInput: 'onboard-email-input',
	submitButton: 'onboard-submit-button',
	successState: 'onboard-success-state',
	restartButton: 'onboard-restart-button',
	editAgain: 'onboard-edit-again',
	stepDot: 'onboard-step-dot',
};
